module.exports = __webpack_public_path__ + "static/media/DogDonation.3dc87b44.png";